<template>
  <div class="admin-home">
    <CSPLoader v-if="loading" />

    <div>
      <v-container grid-list-md class="dashboard-summary">
        <v-layout row>
          <v-flex xs6>
            <v-card class="summary-card summary-card--in" dark>
              <v-card-text class="summary-card__content">
                <span class="summary-card__icon">
                  <v-icon>mdi-account-check</v-icon>
                </span>
                <div class="summary-card__copy">
                  <span>Clocked in</span>
                  <strong>{{ count.clockIn }}</strong>
                  <small>Currently working</small>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs6>
            <v-card class="summary-card summary-card--out" dark>
              <v-card-text class="summary-card__content">
                <span class="summary-card__icon">
                  <v-icon>mdi-account-off</v-icon>
                </span>
                <div class="summary-card__copy">
                  <span>Clocked out</span>
                  <strong>{{ count.clockOut }}</strong>
                  <small>Not currently working</small>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- <v-btn color="success" @click="startTest">start</v-btn>
      <v-btn color="success" @click="endTest">end</v-btn> -->
      <div class="employee-search">
        <v-text-field
          v-model="search"
          class="employee-search__field"
          outlined
          dense
          hide-details
          clearable
          autocomplete="off"
          aria-label="Search employees"
          placeholder="Search employees by name or phone"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
        <span v-if="search" class="employee-search__count">
          {{ filteredItems.length }}
          {{ filteredItems.length === 1 ? "result" : "results" }}
        </span>
      </div>
      <div class="alphabet-filter text-center" v-if="employees.length > 8">
        <v-btn-toggle class="noscroll alphabet-filter__rail">
          <v-btn @click="alfClcik(al)" v-for="(al, index) in alf" :key="index">
            {{ al }}
          </v-btn>
        </v-btn-toggle>
      </div>

      <v-snackbar
        :timeout="-1"
        color="grey lighten-2"
        style="margin-bottom: 60px"
        rounded="pill"
        elevation="24"
        v-model="snackbar"
      >
        <div style="color: black">Search: {{ search }}</div>
        <template v-slot:action="{ attrs }">
          <v-btn icon color="pink" text v-bind="attrs" @click="backString">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn icon color="pink" text v-bind="attrs" @click="clearBtn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
      <CSPLoader :model="true" class="mt-5" v-if="timeClockLoaded" />

      <v-container grid-list-md class="pa-0 mt-3 touch-view-container" v-else>
        <div v-if="showDepartment && showDepartmentSetting">
          <div
            v-for="department in filteredItems"
            :key="department.departmentName"
            class="home-department"
          >
            <div class="home-department__heading">
              <span class="home-department__icon">
                <v-icon small>mdi-account-group</v-icon>
              </span>
              <div>
                <small>Department</small>
                <strong>{{ department.departmentName }}</strong>
              </div>
              <span class="home-department__count">
                {{ department.employees.length }}
              </span>
            </div>

            <!-- :class="i === (filteredItems.length -1) ? 'pa-0 mt-3 touch-view-container' : 'pa-0 mt-3'" -->

            <swipe-list
              v-if="department.employees.length"
              ref="list"
              class="employee-swipe-list"
              :items="department.employees"
              item-key="id"
              id="register-cart-list"
            >
              <template v-slot="{ item, index }">
                <v-list-item
                  class="admin-employee-row"
                  :class="[
                    index % 2 === 0 ? 'even-background' : 'odd-background',
                  ]"
                >
                  <v-list-item-content @click="openQuickReport(item)">
                    <v-list-item-title class="subtitle-2">
                      <v-chip
                        v-if="
                          item.TimeClockPays && item.TimeClockPays.length > 0
                        "
                        x-small
                        label
                        color="pink lighten-4"
                        class="mr-1"
                        >{{ item.TimeClockPays.length }}</v-chip
                      >
                      <v-icon
                        small
                        color="green"
                        v-if="
                          item &&
                          item.metadata &&
                          item.metadata.fingerprintEnrolled
                        "
                      >
                        mdi-fingerprint
                      </v-icon>
                      <v-icon small color="red" v-else>
                        mdi-fingerprint-off
                      </v-icon>
                      <span class="text-capitalize">{{ item.name }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="item.phoneNumber">
                      <span class="caption">
                        {{ item.phoneNumber }}
                      </span>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle
                      class="caption"
                      v-if="item.TimeClocks.length !== 0"
                    >
                      <div v-if="item.TimeClocks[0].status === 'clockedIn'">
                        {{ item.TimeClocks[0].clockInTime | moment("ddd") }} -
                        {{
                          item.TimeClocks[0].clockInTime
                            | moment("M/D/YY h:mm A")
                        }}
                      </div>
                      <div v-else>
                        {{ item.TimeClocks[0].clockOutTime | moment("ddd") }}
                        -
                        {{
                          item.TimeClocks[0].clockOutTime
                            | moment("M/D/YY h:mm A")
                        }}
                      </div>
                    </v-list-item-subtitle>
                    <!-- <v-list-item-subtitle v-if="item.phoneNumber">
                      <span class="caption">{{ item.phoneNumber }}</span>
                    </v-list-item-subtitle> -->
                  </v-list-item-content>
                  <v-list-item-action-text v-if="item.rowLoading">
                    <v-progress-circular
                      indeterminate
                      color="red"
                    ></v-progress-circular>
                  </v-list-item-action-text>
                  <div v-else>
                    <v-list-item-action-text
                      @click="instantClockInOut(item, index)"
                      v-if="item.TimeClocks.length === 0"
                    >
                      Never
                    </v-list-item-action-text>
                    <v-list-item-action-text
                      @click="instantClockInOut(item, index)"
                      v-else
                      class="text-right"
                    >
                      <div
                        class="font-weight-bold green--text text-right"
                        v-if="item.TimeClocks[0].status === 'clockedIn'"
                      >
                        <v-chip color="green" text-color="white">
                          IN
                          <v-avatar right class="green darken-4">
                            <v-icon>mdi-location-enter</v-icon>
                          </v-avatar>
                        </v-chip>
                      </div>

                      <div
                        v-if="item.TimeClocks[0].status === 'clockedIn'"
                        class="caption"
                      >
                        {{
                          item.TimeClocks[0].clockInTime | moment("from", "now")
                        }}
                      </div>

                      <div class="font-weight-bold red--text" v-else>
                        <v-chip color="red" text-color="white">
                          OUT
                          <v-avatar right class="red darken-4">
                            <v-icon>mdi-location-exit</v-icon>
                          </v-avatar>
                        </v-chip>
                      </div>
                    </v-list-item-action-text>
                  </div>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < employees.length"
                  :key="index"
                ></v-divider>
              </template>

              <template
                v-slot:right="{ item, index, close }"
                v-if="
                  employeeAccess.timeClock && employeeAccess.timeClock.inOut
                "
              >
                <v-btn
                  color="error"
                  v-if="item.status === 'clockedIn'"
                  :loading="submitLoading"
                  class="ma-0 btn-size-45 tile"
                  style="height: 100%; min-width: 45px !important"
                  @click.stop.prevent="clockOutEmployee(item, index)"
                >
                  Clock Out
                </v-btn>
                <v-btn
                  v-else
                  color="green"
                  dark
                  :loading="submitLoading"
                  class="ma-0 btn-size-45 tile"
                  style="height: 100%; min-width: 45px !important"
                  @click.stop.prevent="clockInEmployee(item, index)"
                >
                  Clock In
                </v-btn>
                <v-btn
                  color="error"
                  class="ma-0 tile"
                  @click.stop.prevent="close"
                  style="height: 100%; min-width: 45px !important"
                >
                  <v-icon class="pa-3">mdi-close</v-icon>
                </v-btn>
              </template>

              <template
                v-slot:left="{ item, close }"
                v-if="
                  employeeAccess.employee && employeeAccess.employee.viewProfile
                "
              >
                <v-btn
                  v-if="!isReadOnly(item)"
                  color="primary"
                  dark
                  class="ma-0 btn-size-45 tile"
                  style="height: 100%; min-width: 45px !important"
                  @click.stop.prevent="openProfile(item)"
                >
                  Open Profile
                </v-btn>
                <v-btn
                  color="info"
                  class="ma-0 tile"
                  @click.stop.prevent="close"
                  style="height: 100%; min-width: 45px !important"
                >
                  <v-icon class="pa-3">mdi-close</v-icon>
                </v-btn>
              </template>
            </swipe-list>
            <v-layout v-if="employees.length === 0 && !search" class="new-team-empty" row column
              fill-height align-center justify-center>
              <v-flex shrink class="new-team-empty__icon">
                <v-icon>mdi-account-multiple-plus-outline</v-icon>
              </v-flex>
              <v-flex shrink>
                <h2>Build your team</h2>
                <p>Add your first employee to start tracking attendance, hours, and pay.</p>
              </v-flex>
              <v-flex shrink>
                <v-btn
                  @click="createEmployee"
                  class="new-team-empty__button"
                  color="primary"
                  rounded
                  large
                  ><v-icon left>mdi-plus</v-icon>Add first employee</v-btn
                >
              </v-flex>
            </v-layout>
          </div>
        </div>

        <div v-else>
          <swipe-list
            v-if="filteredItems.length"
            ref="list"
            class="employee-swipe-list"
            :items="filteredItems"
            item-key="id"
            id="register-cart-list"
          >
            <template v-slot="{ item, index }">
              <v-list-item
                class="admin-employee-row"
                :class="[
                  index % 2 === 0 ? 'even-background' : 'odd-background',
                ]"
              >
                <v-list-item-content @click="openQuickReport(item)">
                  <v-list-item-title class="subtitle-2">
                    <v-chip
                      v-if="item.TimeClockPays && item.TimeClockPays.length > 0"
                      x-small
                      label
                      color="pink lighten-4"
                      class="mr-1"
                      >{{ item.TimeClockPays.length }}</v-chip
                    >
                    <v-icon
                      small
                      color="green"
                      v-if="
                        item &&
                        item.metadata &&
                        item.metadata.fingerprintEnrolled
                      "
                    >
                      mdi-fingerprint
                    </v-icon>
                    <v-icon small color="red" v-else>
                      mdi-fingerprint-off
                    </v-icon>
                    <span class="text-capitalize">{{ item.name }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="item.phoneNumber">
                    <span class="caption">
                      {{ item.phoneNumber }}
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                    class="caption"
                    v-if="item.TimeClocks.length !== 0"
                  >
                    <div v-if="item.TimeClocks[0].status === 'clockedIn'">
                      {{ item.TimeClocks[0].clockInTime | moment("ddd") }} -
                      {{
                        item.TimeClocks[0].clockInTime | moment("M/D/YY h:mm A")
                      }}
                    </div>
                    <div v-else>
                      {{ item.TimeClocks[0].clockOutTime | moment("ddd") }}
                      -
                      {{
                        item.TimeClocks[0].clockOutTime
                          | moment("M/D/YY h:mm A")
                      }}
                    </div>
                  </v-list-item-subtitle>
                  <!-- <v-list-item-subtitle v-if="item.phoneNumber">
                    <span class="caption">{{ item.phoneNumber }}</span>
                  </v-list-item-subtitle> -->
                </v-list-item-content>
                <v-list-item-action-text v-if="item.rowLoading">
                  <v-progress-circular
                    indeterminate
                    color="red"
                  ></v-progress-circular>
                </v-list-item-action-text>
                <div v-else>
                  <v-list-item-action-text
                    @click="instantClockInOut(item, index)"
                    v-if="item.TimeClocks.length === 0"
                  >
                    Never
                  </v-list-item-action-text>
                  <v-list-item-action-text
                    @click="instantClockInOut(item, index)"
                    v-else
                    class="text-right"
                  >
                    <div
                      class="font-weight-bold green--text text-right"
                      v-if="item.TimeClocks[0].status === 'clockedIn'"
                    >
                      <v-chip color="green" text-color="white">
                        IN
                        <v-avatar right class="green darken-4">
                          <v-icon>mdi-location-enter</v-icon>
                        </v-avatar>
                      </v-chip>
                    </div>

                    <div
                      v-if="item.TimeClocks[0].status === 'clockedIn'"
                      class="caption"
                    >
                      {{
                        item.TimeClocks[0].clockInTime | moment("from", "now")
                      }}
                    </div>

                    <div class="font-weight-bold red--text" v-else>
                      <v-chip color="red" text-color="white">
                        OUT
                        <v-avatar right class="red darken-4">
                          <v-icon>mdi-location-exit</v-icon>
                        </v-avatar>
                      </v-chip>
                    </div>
                  </v-list-item-action-text>
                </div>
              </v-list-item>
              <v-divider
                v-if="index + 1 < employees.length"
                :key="index"
              ></v-divider>
            </template>

            <template
              v-slot:right="{ item, index, close }"
              v-if="employeeAccess.timeClock && employeeAccess.timeClock.inOut"
            >
              <v-btn
                color="error"
                v-if="item.status === 'clockedIn'"
                :loading="submitLoading"
                class="ma-0 btn-size-45 tile"
                style="height: 100%; min-width: 45px !important"
                @click.stop.prevent="clockOutEmployee(item, index)"
              >
                Clock Out
              </v-btn>
              <v-btn
                v-else
                color="green"
                dark
                :loading="submitLoading"
                class="ma-0 btn-size-45 tile"
                style="height: 100%; min-width: 45px !important"
                @click.stop.prevent="clockInEmployee(item, index)"
              >
                Clock In
              </v-btn>
              <v-btn
                color="error"
                class="ma-0 tile"
                @click.stop.prevent="close"
                style="height: 100%; min-width: 45px !important"
              >
                <v-icon class="pa-3">mdi-close</v-icon>
              </v-btn>
            </template>

            <template
              v-slot:left="{ item, close }"
              v-if="
                employeeAccess.employee && employeeAccess.employee.viewProfile
              "
            >
              <v-btn
                v-if="!isReadOnly(item)"
                color="primary"
                dark
                class="ma-0 btn-size-45 tile"
                style="height: 100%; min-width: 45px !important"
                @click.stop.prevent="openProfile(item)"
              >
                Open Profile
              </v-btn>
              <v-btn
                color="info"
                class="ma-0 tile"
                @click.stop.prevent="close"
                style="height: 100%; min-width: 45px !important"
              >
                <v-icon class="pa-3">mdi-close</v-icon>
              </v-btn>
            </template>
          </swipe-list>

          <div v-if="search" class="employee-search-empty">
            <span class="employee-search-empty__icon"><v-icon>mdi-account-search-outline</v-icon></span>
            <strong>No employees found</strong>
            <p>Try another name or phone number.</p>
            <v-btn text color="primary" @click="clearBtn">Clear search</v-btn>
          </div>
          <v-layout v-if="employees.length === 0 && !search" class="new-team-empty" row column
            fill-height align-center justify-center>
            <v-flex shrink class="new-team-empty__icon">
              <v-icon>mdi-account-multiple-plus-outline</v-icon>
            </v-flex>
            <v-flex shrink>
              <h2>Build your team</h2>
              <p>Add your first employee to start tracking attendance, hours, and pay.</p>
            </v-flex>
            <v-flex shrink>
              <v-btn
                @click="createEmployee"
                class="new-team-empty__button"
                color="primary"
                rounded
                large
                ><v-icon left>mdi-plus</v-icon>Add first employee</v-btn
              >
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <ClockInOut
      :dialog="dialog"
      :selectedRow="selectedRow"
      @submit="submitWithClockIn"
      @cancel="cancel"
    />

    <Profile
      @close="close"
      :dialog="profileDialog"
      :employee="selectedEmployeeRow"
    />

    <QuickReport
      @close="closeQuickReport"
      :dialog="quickReportDialog"
      :selectedRow="selectedRow"
    />
  </div>
</template>

<script>
// eslint-disable-line no-mixed-spaces-and-tabs
// import Appbar from "@/components/Appbar";
import locationService from "@/modules/Location/service.js";
import DateTimeTextField from "@/components/DateTimeTextField.vue";
import employeeService from "@/modules/Employee/service";
import timeClockService from "@/modules/TimeClock/service.js";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import Profile from "@/modules/Employee/components/Profile.vue";
import ClockInOut from "@/modules/Home/components/ClockInOut.vue";
import { mapActions, mapGetters } from "vuex";
import QuickReport from "@/modules/Reports/components/QuickReport.vue";

export default {
  name: "home",
  data() {
    return {
      showDepartment: false,
      showDepartmentSetting: false,
      location: null,
      snackbar: false,
      quickReportDialog: false,
      search: "",
      recentLocation: null,
      groupedEmployees: [],
      picture: "",
      submitLoading: false,
      profileDialog: false,
      timeClockLoaded: true,
      selectedRowIndex: null,
      selectedEmployeeRow: null,
      selectedRow: null,
      dialog: false,
      locationCode: null,
      location: null,
      deviceCode: null,
      deviceName: null,
      employees: [],
      loading: false,
      selectedEmployee: null,
      clockedInEmployees: [],
      clockedOutEmployees: [],
      count: {
        clockIn: 0,
        clockOut: 0,
      },
      alf: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  components: {
    ClockInOut,
    Profile,
    QuickReport,
    SwipeOut,
    SwipeList,
    DateTimeTextField,
  },
  sockets: {
    employeeStatusChange(val) {
      console.log("employeeStatusChange", val);
      this.getEmployeesList();
    },
  },
  watch: {
    search(val) {
      if (!val || val.length === 0) {
        this.showDepartment = true;
        this.snackbar = false;
      } else {
        this.showDepartment = false;
      }
    },
  },
  computed: {
    ...mapGetters("employee", ["employee", "employeeAccess"]),
    filteredItems() {
      if (this.search) {
        const query = this.search.toLowerCase().trim();
        return this.employees.filter((item) => {
          const name = item.name ? item.name.toLowerCase() : "";
          const phone = item.phoneNumber ? String(item.phoneNumber).toLowerCase() : "";
          return name.indexOf(query) > -1 || phone.indexOf(query) > -1;
        });
      } else {
        if (
          !this.groupedEmployees.length ||
          this.groupedEmployees.length === 1 ||
          !this.showDepartmentSetting
        ) {
          return this.employees;
        } else {
          return this.groupedEmployees;
        }
      }
    },
  },
  async created() {
    let localLocation = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}location`
    );

    if (localLocation) {
      localLocation = JSON.parse(localLocation);
      // console.log("location", localLocation);

      locationService.Terminal.getById(localLocation.id).then((response) => {
        // console.log('respond Terminal', response)
        this.location = response.data;
        if (
          this.location &&
          this.location.metadata &&
          this.location.metadata.isLocked
        ) {
          this.$router.push({
            name: "no-subscription",
            params: {
              // subscription: this.subscription,
              location: this.Location,
            },
          });
        }
        if (
          this.location &&
          this.location.metadata &&
          this.location.metadata.customClockIn &&
          this.location.metadata.customClockIn.showDepartment
        ) {
          this.showDepartmentSetting = true;
        } else {
          this.showDepartmentSetting = false;
        }
      }).catch((error) => {
        console.log("Unable to load location", error);
      });
    }

    this.recentLocation = JSON.parse(
      localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`
      )
    );
    if (!this.recentLocation) this.recentLocation = [];
    this.location = JSON.parse(
      localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
    );

    this.getEmployeesList();
  },
  methods: {
    ...mapActions("employee", ["setEmployee"]),
    ...mapActions("global", ["setLocation"]),
    startTest() {
      timeClockService
        .restrictiveTime()
        .then(async (result) => {
          console.log("result", result);
        })
        .catch((err) => {
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 3000,
          });
          this.submitLoading = false;
          console.log(err ? err.message : err);
        });
    },
    endTest() {
      timeClockService
        .restrictiveTime()
        .then(async (result) => {
          console.log("result", result);
        })
        .catch((err) => {
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 3000,
          });
          this.submitLoading = false;
          console.log(err ? err.message : err);
        });
    },
    createEmployee() {
      this.$router.push({ name: "employee-create" });
    },
    // if selected employee is owner and its not editing himself then make it readOnly
    isReadOnly(selectedEmployee) {
      if (selectedEmployee.owner && this.employee.id != selectedEmployee.id)
        return true;
      else return false;
    },
    closeQuickReport() {
      console.log("quick report close");
      this.quickReportDialog = false;
    },
    openQuickReport(row) {
      if (
        this.employeeAccess.timeClock &&
        !this.employeeAccess.timeClock.instantReport
      ) {
        return false;
      }
      console.log("item val", row);
      this.selectedRow = row;
      this.quickReportDialog = !this.quickReportDialog;
    },
    backString() {
      this.search = this.search.substring(0, this.search.length - 1);
    },
    clearBtn() {
      this.snackbar = false;
      this.search = "";
    },
    alfClcik(lat) {
      this.snackbar = true;
      // console.log("lat press", this.search, lat);
      this.search += lat;
    },
    instantClockInOut(item) {
      console.log("item", this.employeeAccess);
      if (
        this.employeeAccess.timeClock &&
        !this.employeeAccess.timeClock.instant
      ) {
        return false;
      }

      item.rowLoading = true;
      let selectedRow = {};

      if (item.TimeClocks.length) {
        selectedRow = item.TimeClocks[0];
        if (selectedRow.status === "clockedIn") {
          selectedRow.clockOutTime = this.$moment();
          selectedRow.admin = true;
          console.log("clock out");
          timeClockService
            .clockOut(selectedRow)
            .then(async () => {
              await this.getEmployeesList();
              item.rowLoading = false;
            })
            .catch((err) => {
              this.$toast.error(err.data ? err.data.message : "Error", {
                timeout: 3000,
              });
              this.submitLoading = false;
              console.log(err ? err.message : err);
            });
        } else {
          selectedRow.clockInTime = this.$moment();
          selectedRow.admin = true;
          console.log("clock in");
          timeClockService
            .clockIn(selectedRow)
            .then(async () => {
              await this.getEmployeesList();
              item.rowLoading = false;
            })
            .catch((err) => {
              this.$toast.error(err.data ? err.data.message : "Error", {
                timeout: 3000,
              });
              this.submitLoading = false;
              console.log(err ? err.message : err);
            });
        }
      } else {
        console.log("never was enter");
        selectedRow.clockInTime = this.$moment();
        selectedRow.admin = true;
        selectedRow.EmployeeId = item.id;
        console.log("clock in");
        timeClockService
          .clockIn(selectedRow)
          .then(async () => {
            await this.getEmployeesList();
            item.rowLoading = false;
          })
          .catch((err) => {
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 3000,
            });
            this.submitLoading = false;
            console.log(err ? err.message : err);
          });
      }
    },
    openProfile(obj) {
      // console.log("profile", obj);
      this.selectedEmployeeRow = obj;
      this.profileDialog = true;
    },
    cancel() {
      this.selectedRow.clockOutTime = null;
      this.selectedRowIndex = null;
      // this.$refs.list.closeActions(0);
      this.$refs.list.closeActions();
      // console.log('list', this.$refs.list)
      // this.$refs.list.forEach(row => {
      //   row.closeActions();
      // })
      this.submitLoading = false;
      this.dialog = false;
    },
    close() {
      this.profileDialog = false;

      this.$refs.list.forEach((row) => {
        row.closeActions();
      });
    },
    submitWithClockIn() {
      this.submitLoading = false;
      this.dialog = false;
      // this.$refs.list.closeActions();
      this.getEmployeesList();
    },
    clockOutEmployee(e, i) {
      this.submitLoading = true;
      // this.selectedRow.clockOutTime = this.$moment();
      this.selectedRow = e.TimeClocks[0];
      this.selectedRowIndex = i;
      this.dialog = true;
    },
    clockInEmployee(e, i) {
      let clockIn = {
        status: e.status,
        PinCode: e.pinCode,
        clockInTime: this.$moment(),
      };
      if (e.TimeClocks.length !== 0) {
        clockIn.EmployeeId = e.TimeClocks[0].EmployeeId;
      } else {
        clockIn.EmployeeId = e.id;
      }
      this.selectedRow = clockIn;
      // {
      //   EmployeeId: (e.TimeClocks[0].EmployeeId ? e.id : e.TimeClocks[0].EmployeeId),
      //   status: e.status,
      //   PinCode: e.pinCode,
      //   clockInTime: this.$moment(),
      // };
      this.selectedRowIndex = i;
      this.dialog = true;
    },
    getEmployeesList() {
      // console.log('currentEmployee', this.employeeAccess)
      return employeeService
        .getAll({
          timeClock: true,
          limit: 50,
          offset: 0,
          local: true,
        })
        .then(async (response) => {
          let employee = response.data;
          console.log("employee", employee);
          this.employees = [];
          this.groupedEmployees = [];
          this.count = {
            clockIn: 0,
            clockOut: 0,
          };
          employee.map((row) => {
            row.rowLoading = false;
            if (
              row.metadata &&
              row.metadata.timeClockLogin &&
              row.metadata.timeClockLogin.employee
            ) {
              if (row.TimeClocks.length > 0) {
                row.status = row.TimeClocks[0].status;
                if (row.status === "clockedIn") {
                  this.count.clockIn++;
                } else {
                  this.count.clockOut++;
                }
              } else {
                row.status = "never";
              }
              if (this.employeeAccess.onlyView) {
                this.employeeAccess.onlyViewEmployee.map((emp) => {
                  if (emp === row.id) {
                    this.employees.push(row);
                  }
                });
              } else {
                this.employees.push(row);
              }
            }
          });
          if (this.showDepartmentSetting === true) {
            const grouped = this.employees.reduce((acc, employee) => {
              const deptId = employee.DepartmentId
                ? employee.DepartmentId
                : "Unassigned";
              if (!acc[deptId]) {
                acc[deptId] = {
                  departmentName: employee.Department
                    ? employee.Department.name
                    : "Unassigned",
                  employees: [],
                };
              }
              acc[deptId].employees.push(employee);
              return acc;
            }, {});

            const sortedDepartments = Object.values(grouped).sort((a, b) =>
              a.departmentName.localeCompare(b.departmentName)
            );

            sortedDepartments.forEach((department) => {
              department.employees.sort((a, b) => a.name.localeCompare(b.name));
            });

            this.groupedEmployees = sortedDepartments;

            if (this.groupedEmployees.length === 1) {
              this.showDepartment = false;
            } else {
              this.showDepartment = true;
            }
          }

          this.timeClockLoaded = false;
          // console.log("employees", this.groupedEmployees);
        })
        .catch((error) => {
          this.timeClockLoaded = false;
          throw error;
        });
    },
  },
};
</script>

<style scoped>
.admin-home {
  min-height: 100%;
  padding-bottom: 76px;
}

.dashboard-summary {
  max-width: 1185px;
  padding-top: 18px;
  padding-bottom: 8px;
}

.summary-card {
  overflow: hidden;
  min-height: 78px;
  border: 1px solid transparent;
  border-radius: 16px !important;
  box-shadow: none !important;
}

.summary-card--in {
  border-color: rgba(52, 211, 153, 0.22);
  background: linear-gradient(
      135deg,
      rgba(16, 185, 129, 0.2),
      rgba(16, 185, 129, 0.08)
    ),
    var(--v-surface-base) !important;
}

.summary-card--out {
  border-color: rgba(251, 113, 133, 0.22);
  background: linear-gradient(
      135deg,
      rgba(244, 63, 94, 0.18),
      rgba(244, 63, 94, 0.07)
    ),
    var(--v-surface-base) !important;
}

.summary-card__content {
  display: flex;
  min-height: 92px;
  padding: 14px 18px !important;
  align-items: center;
  justify-content: center;
  gap: 14px;
}

.summary-card__icon {
  display: grid;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  place-items: center;
  border: 1px solid currentColor;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.04);
  opacity: 0.9;
}

.summary-card__icon .v-icon {
  color: inherit !important;
}

.summary-card__copy {
  display: grid;
  grid-template-columns: auto auto;
  align-items: baseline;
  column-gap: 10px;
  text-align: left;
}

.summary-card__copy span {
  color: inherit;
  font-size: 13px;
  font-weight: 750;
}

.summary-card__copy strong {
  grid-row: 1 / span 2;
  grid-column: 2;
  color: inherit;
  font-size: 34px;
  line-height: 1;
}

.summary-card__copy small {
  color: #94a3b8;
  font-size: 10px;
}

.summary-card--in ::v-deep .v-card__text {
  color: #6ee7b7 !important;
}

.summary-card--out ::v-deep .v-card__text {
  color: #fda4af !important;
}

.theme--light .summary-card--in {
  border-color: rgba(8, 122, 85, 0.28);
  background: linear-gradient(
      135deg,
      rgba(8, 122, 85, 0.13),
      rgba(255, 255, 255, 0.98)
    ) !important;
}

.theme--light .summary-card--out {
  border-color: rgba(214, 47, 75, 0.25);
  background: linear-gradient(
      135deg,
      rgba(214, 47, 75, 0.11),
      rgba(255, 255, 255, 0.98)
    ) !important;
}

.theme--light .summary-card--in ::v-deep .v-card__text {
  color: #087a55 !important;
}

.theme--light .summary-card--out ::v-deep .v-card__text {
  color: #c72946 !important;
}

.theme--light .summary-card__copy small {
  color: #607086;
}

.theme--light .summary-card__icon {
  background: rgba(255, 255, 255, 0.72);
}

.employee-search {
  align-items: center;
  display: flex;
  gap: 10px;
  margin: 2px auto 0;
  max-width: 1185px;
  padding: 0 12px;
}

.employee-search__field {
  max-width: 100%;
}

.employee-search__field ::v-deep .v-input__slot {
  background: var(--v-surface-base) !important;
  border-radius: 13px !important;
  color: var(--v-textPrimary-base);
  min-height: 46px !important;
}

.employee-search__field ::v-deep fieldset {
  border-color: var(--v-border-base) !important;
}

.employee-search__field ::v-deep .v-input__slot:hover fieldset,
.employee-search__field ::v-deep .v-input--is-focused fieldset {
  border-color: var(--v-primary-base) !important;
}

.employee-search__field ::v-deep input {
  color: var(--v-textPrimary-base) !important;
  font-size: 0.85rem;
}

.employee-search__field ::v-deep input::placeholder {
  color: var(--v-textSecondary-base) !important;
  opacity: 1;
}

.employee-search__field ::v-deep .v-icon {
  color: var(--v-textSecondary-base);
}

.employee-search__count {
  color: var(--v-textSecondary-base);
  flex: 0 0 auto;
  font-size: 0.72rem;
  font-weight: 700;
}

.employee-search-empty {
  align-items: center;
  color: var(--v-textSecondary-base);
  display: flex;
  flex-direction: column;
  padding: 46px 16px;
  text-align: center;
}

.employee-search-empty__icon {
  align-items: center;
  background: var(--v-surfaceMuted-base);
  border: 1px solid var(--v-border-base);
  border-radius: 16px;
  display: flex;
  height: 52px;
  justify-content: center;
  margin-bottom: 12px;
  width: 52px;
}

.employee-search-empty__icon .v-icon {
  color: var(--v-primary-base);
}

.employee-search-empty strong {
  color: var(--v-textPrimary-base);
}

.employee-search-empty p {
  font-size: 0.78rem;
  margin: 4px 0 5px;
}

.new-team-empty {
  background: var(--v-surface-base);
  border: 1px dashed var(--v-border-base);
  border-radius: 18px;
  color: var(--v-textSecondary-base);
  margin-top: 16px;
  min-height: 280px;
  padding: 36px 20px;
  text-align: center;
}

.new-team-empty__icon {
  align-items: center;
  background: rgba(96, 165, 250, 0.12);
  border: 1px solid rgba(96, 165, 250, 0.25);
  border-radius: 18px;
  display: flex;
  height: 64px;
  justify-content: center;
  margin-bottom: 16px;
  width: 64px;
}

.new-team-empty__icon .v-icon {
  color: var(--v-primary-base);
  font-size: 30px;
}

.new-team-empty h2 {
  color: var(--v-textPrimary-base);
  font-size: 1.35rem;
  margin-bottom: 6px;
}

.new-team-empty p {
  font-size: 0.82rem;
  margin: 0 auto 20px;
  max-width: 370px;
}

.new-team-empty__button {
  font-weight: 750;
  letter-spacing: 0;
  text-transform: none;
}

.alphabet-filter {
  max-width: 1185px;
  margin: 0 auto;
  padding: 6px 12px 8px;
}

.alphabet-filter__rail {
  display: flex;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 13px;
  background: var(--v-surface-base) !important;
}

.alphabet-filter__rail ::v-deep .v-btn {
  min-width: 44px !important;
  flex: 1 0 44px !important;
  border-color: rgba(148, 163, 184, 0.12) !important;
  color: inherit !important;
}

.home-department + .home-department {
  margin-top: 18px;
}

.home-department__heading {
  display: flex;
  min-height: 58px;
  margin: 0 0 8px;
  padding: 10px 13px;
  align-items: center;
  gap: 11px;
  border: 1px solid rgba(96, 165, 250, 0.18);
  border-radius: 14px;
  background: linear-gradient(
      90deg,
      rgba(37, 99, 235, 0.12),
      rgba(34, 211, 238, 0.035)
    ),
    var(--v-surface-base);
}

.home-department__icon {
  display: grid;
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  place-items: center;
  border-radius: 10px;
  background: rgba(34, 211, 238, 0.1);
}

.home-department__icon .v-icon {
  color: var(--v-accent-base) !important;
}

.home-department__heading small,
.home-department__heading strong {
  display: block;
}

.home-department__heading small {
  color: #7f91a9;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.home-department__heading strong {
  font-size: 15px;
}

.home-department__count {
  min-width: 30px;
  margin-left: auto;
  padding: 5px 8px;
  border-radius: 999px;
  background: rgba(96, 165, 250, 0.12);
  color: #93c5fd;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
}

.employee-swipe-list {
  overflow: hidden;
  border: 1px solid rgba(148, 163, 184, 0.14);
  border-radius: 15px;
  background: var(--v-surface-base) !important;
}

.employee-swipe-list
  ::v-deep
  .swipeout-list-item
  + .swipeout-list-item {
  border-top: 1px solid rgba(148, 163, 184, 0.12);
}

.employee-swipe-list ::v-deep .swipeout-content {
  background: var(--v-surface-base) !important;
}

.employee-swipe-list ::v-deep .admin-employee-row {
  min-height: 72px;
  background: transparent !important;
}

.employee-swipe-list
  ::v-deep
  .admin-employee-row.even-background,
.employee-swipe-list
  ::v-deep
  .admin-employee-row.odd-background {
  background: transparent !important;
}

.employee-swipe-list ::v-deep .v-list-item__title {
  color: inherit !important;
  line-height: 1.35;
}

.employee-swipe-list ::v-deep .v-list-item__subtitle,
.employee-swipe-list ::v-deep .v-list-item__action-text {
  color: #94a3b8 !important;
}

.theme--light .employee-swipe-list {
  border-color: #d8e1ed;
  box-shadow: 0 8px 24px rgba(37, 55, 82, 0.06);
}

.theme--light .employee-swipe-list
  ::v-deep
  .swipeout-list-item
  + .swipeout-list-item {
  border-top-color: #e3e9f1;
}

.theme--light .employee-swipe-list ::v-deep .v-list-item__title {
  color: #172235 !important;
}

.theme--light .employee-swipe-list ::v-deep .v-list-item__subtitle,
.theme--light .employee-swipe-list ::v-deep .v-list-item__action-text {
  color: #68788e !important;
}

.theme--light .employee-swipe-list ::v-deep .mdi-fingerprint {
  color: #087a55 !important;
}

.theme--light .home-department__heading {
  border-color: #cddbeb;
  background: linear-gradient(90deg, #edf5ff, #f7fbff), #ffffff;
}

.theme--light .home-department__heading small {
  color: #5d6b7e;
}

.theme--light .home-department__count {
  background: #e1edfc;
  color: #255a9f;
}

.theme--light .alphabet-filter__rail {
  border-color: #d8e1ed;
  box-shadow: 0 5px 16px rgba(37, 55, 82, 0.05);
}

.theme--light .alphabet-filter__rail ::v-deep .v-btn {
  border-color: #e0e6ee !important;
  color: #40506a !important;
}

.employee-swipe-list ::v-deep .v-divider {
  display: none;
}

.employee-swipe-list ::v-deep .mdi-fingerprint {
  color: #34d399 !important;
}

.employee-swipe-list ::v-deep .mdi-fingerprint-off {
  color: #94a3b8 !important;
}

.card-labels {
  display: block;
}

/* .touch-view-container {
  width: 100%;
  overflow: auto;
} */

.touch-view-container {
  height: calc(100vh - 300px);
  width: 100%;
  overflow: auto;
  padding: 0 12px !important;
}

.noscroll {
  overflow-y: scroll;
}

div::-webkit-scrollbar {
  display: none;
  /* for Chrome, Safari, and Opera */
}

@media (max-width: 600px) {
  .dashboard-summary {
    padding: 12px 12px 5px;
  }

  .summary-card {
    min-height: 108px;
  }

  .summary-card__content {
    min-height: 108px;
    padding: 12px 9px !important;
    flex-direction: column;
    gap: 7px;
  }

  .summary-card__icon {
    display: none;
  }

  .summary-card__copy {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    text-align: center;
  }

  .summary-card__copy strong {
    order: -1;
    font-size: 32px;
  }

  .summary-card__copy small {
    display: none;
  }

  .employee-search {
    padding: 2px 12px 0;
  }

  .employee-search__count {
    display: none;
  }

  .alphabet-filter {
    display: none;
  }

  .touch-view-container {
    height: calc(100vh - 348px);
  }

  .employee-swipe-list ::v-deep .admin-employee-row {
    min-height: 76px;
    padding: 0 12px;
  }
}
</style>
